export default __webpack_public_path__ + "static/media/search_icon.e45880d5.svg";